module.exports = __webpack_public_path__ + "static/media/SWSCRC6-50.ea05452c.mp3";